import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

export interface AcceptanceDocumentsKeyType {
  accepting: LocalesKey;
  actionRequired: LocalesKey;
  confirmConsent: LocalesKey;
  dearUser: LocalesKey;
  notReadyToAccept: LocalesKey;
  restrictedAccessNotice: LocalesKey;
  termsUpdateDescription: LocalesKey;
  updatedDocuments: LocalesKey;
  updatedTerms: LocalesKey;
}

export const acceptanceDocumentsKeys = keyPathMirror<
  AcceptanceDocumentsKeyType,
  string
>(
  {
    accepting: null,
    actionRequired: null,
    confirmConsent: null,
    dearUser: null,
    notReadyToAccept: null,
    restrictedAccessNotice: null,
    termsUpdateDescription: null,
    updatedDocuments: null,
    updatedTerms: null
  },
  'models.acceptanceDocuments.'
);
